module.exports = __webpack_public_path__ + "media/images/logos/neue-grenz-apotheke-038b17ca0fac380371b8c6ec52f9dd59.png";